<template>
	<div class="news">
		<div class="news_header">
			<div class="w1200 flex">
				<router-link to="/" class="header_logo"><img :src="public.bottom_logo" class="block" /></router-link>
				<div class="header_nav f18px">
					<ul>
						<li class="header_nav_list"><router-link to="/" class="cl_white">首页</router-link></li>
						<li class="header_nav_list"><router-link to="/study" class="cl_white">趣学习</router-link></li>
						<li class="header_nav_list"><router-link to="/career" class="cl_white">生涯规划</router-link></li>
						<li class="header_nav_list"><router-link to="/wish" class="cl_white">志愿填报</router-link></li>
						<li class="header_nav_list on"><router-link to="/news_list" class="cl_white">高中资讯</router-link></li>
					</ul>
				</div>
				<div class="news_header_r" v-if="token == null">
					<router-link to="/" class="cl_white f16px">登录</router-link>
					&nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/logon" class="cl_white f16px">注册</router-link>
				</div>
				<div class="news_header_r" v-else>
					<router-link to="/personal" class="flex cl_white news_header_info">
						<img :src="myInfo.avatar" class="radius mar10" />
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) < 0">{{myInfo.real_name}}</span>
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) < 0">{{myInfo.name}}</span>
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) > 0">{{myInfo.wx_nickname}}</span>
					</router-link>
				</div>
			</div>
		</div>
		<div class="news_details w1200">
			<div class="news_details_l">
				<div class="news_details_l_title">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/news_list" class="cl_gray">高中资讯</router-link>  >  {{details.name}}</p>
					</div>
				</div>
				<div class="news_details_div" v-if="JSON.stringify(details) != '{}'">
					<div class="news_details_title">
						<h3 class="f26px mat10">{{details.name}}</h3>
						<p class="cl_gray mat10">更新时间：{{details.add_time}}</p>
					</div>
					<div class="news_details_cont f16px cl_gray" v-html="details.content"></div>
				</div>
				<div class="news_details_btm">
					<router-link to="/news_list" class="cl_blue">< 返回列表</router-link>
				</div>
			</div>
			<div class="news_details_r radius8">
				<div class="news_details_r_title f20px cl_dark">相关资讯</div>
				<img src="../../../static/news_list_icon.png" class="block mat5 news_details_r_img" />
				<div class="news_details_r_cont mat20">
					<router-link :to="{ path: '/news_details', query: { id: item.id}}" class="clip cl_blue block" v-for="item in details.recommend_senior_info">·{{item.name}}</router-link>
				</div>
			</div>
		</div>
		<vfooter @child-event="parentEvent"></vfooter>
	</div>
</template>

<script>
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'news_details',
		components: {
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				public: {}, //公共部分
				token: localStorage.getItem("token"),
				myInfo: {}, //个人信息
				id: "",
				details: {},
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.getDetails();
		},
		mounted() {
			if (localStorage.getItem("token")) {
				this.getMyinfo();
			}
		},
		watch: {
			$route: {
				handler () {
					this.id = this.$route.query.id;
					this.getDetails();
				}
			}
		},
		methods: {
			parentEvent (data) {
				this.public = data;
			},
			//获取用户信息
			getMyinfo () {
				var that = this;
				that.$get("/api/user/get_user_info",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					that.myInfo = res.data;
				});
			},
			//获取详情
			getDetails () {
				var that = this;
				that.$get("/api/seniorinfo/get_senior_info_dtl",{
					id: that.id
				})
				.then(res => {
					that.details = res.data;
				});
			},
		},
	}
</script>

<style>
</style>
